// extracted by css-extract-rspack-plugin
export default {"AppBarRoot":"MdZZp"};